interface Company {
  COMPANY_TYPES: CompanyConfig[];
}

export interface CompanyConfig {
  /**
   * Código de la compañia
   */
  code: string;
  /**
   * Nombre de la compañia
   */
  name: string;
  /**
   * Aplica descuento de promoción en venta cliente
   */
  applyPromotionDiscount: boolean;
  /**
   * Requiere impresión de guías para despachar el vieja de despachos
   */
  printGuideToSendTrip: boolean;
  /**
   * Aplicar venta de producto medible por venta cliente
   */
  applyMeasurableProductSale
  /**
   * Aplicar venta de servicio por venta cliente
   */
  applySaleOfServices
  /**
   * Carga por defecto
   */
  default: boolean;
    /**
   * Lista de tipos de despachos enviados desde el vtex
   * no se considera tipo de despacho primario NORMAL
   */
  despachoVTX: string[]
  /**
   * generar NV y cotización con skus duplicados
   */
  applySkuDuplicate: boolean
    /**
   * Aplicar CD como origen de venta al crear cotizaciones
   */
  applySaleEntityCd: boolean,
    /**
   * Anular cotizaciones y Nv con método de pago cuenta recaudadora
   */
  anulationCollenctionAccount: boolean;
    /**
   *
   */
  listSaleEntityCDWithDirectSale: string[];
  hierarchies: string[];

  showOcInputs?: boolean;
}

export const Country = {
  PERU: 'PE',
  ECUADOR: 'EC'
}

export const maxLengthyCountry = {
  fieldCellNumber: {
    EC: 10,
    PE: 9
  }
}

export const igvNumber = {
    EC: 0.15,
    PE: 0.18
}

export const igvNumberDefault = {
  EC: 1.15,
  PE: 1.18
}
export const igvText = {
  EC: 'IVA',
  PE: 'IGV'
}
export const Company: Company = {
  COMPANY_TYPES: [
    {
      code: 'OE',
      name: 'OESHLE',
      applyPromotionDiscount: true,
      printGuideToSendTrip: false,
      applyMeasurableProductSale: true,
      applySkuDuplicate: true,
      applySaleEntityCd: false,
      applySaleOfServices: true,
      default: true,
      despachoVTX: ['EXPRESS'],
      anulationCollenctionAccount: false,
      listSaleEntityCDWithDirectSale: [],
      hierarchies: ['division', 'area', 'departmento', 'linea']
    },
    {
      code: 'PRO',
      name: 'PROMART',
      applyPromotionDiscount: false,
      printGuideToSendTrip: true,
      applyMeasurableProductSale: false,
      applySkuDuplicate: true,
      applySaleEntityCd: false,
      applySaleOfServices: false,
      default: false,
      despachoVTX: [],
      anulationCollenctionAccount: true,
      listSaleEntityCDWithDirectSale: [],
      hierarchies: ['division', 'area', 'departmento', 'linea']
    },
    {
      code: 'SPSA',
      name: 'SUPERMERCADOS PERUANOS',
      applyPromotionDiscount: true,
      printGuideToSendTrip: false,
      applyMeasurableProductSale: true,
      applySkuDuplicate: true,
      applySaleEntityCd: true,
      applySaleOfServices: true,
      default: false,
      despachoVTX: [],
      anulationCollenctionAccount: true,
      listSaleEntityCDWithDirectSale: ['SPSA-945', 'SPSA-919'],
      hierarchies: ['area', 'seccion', 'linea', 'familia']
    },
    {
      code: 'RP',
      name: 'REAL PLAZA',
      applyPromotionDiscount: true,
      printGuideToSendTrip: false,
      applyMeasurableProductSale: true,
      applySkuDuplicate: true,
      applySaleEntityCd: false,
      applySaleOfServices: true,
      default: false,
      despachoVTX: [],
      anulationCollenctionAccount: false,
      listSaleEntityCDWithDirectSale: [],
      hierarchies: ['division','area','departmento','linea']
    },
    {
      code: 'AGO',
      name: 'AGORA',
      applyPromotionDiscount: true,
      printGuideToSendTrip: false,
      applyMeasurableProductSale: true,
      applySkuDuplicate: true,
      applySaleEntityCd: false,
      applySaleOfServices: true,
      default: false,
      despachoVTX: [],
      anulationCollenctionAccount: false,
      listSaleEntityCDWithDirectSale: [],
      hierarchies: ['division','area','departmento','linea']
    },
    {
      code: 'INKA',
      name: 'INKAFARMA',
      applyPromotionDiscount: true,
      printGuideToSendTrip: false,
      applyMeasurableProductSale: true,
      applySkuDuplicate: true,
      applySaleEntityCd: false,
      applySaleOfServices: true,
      default: false,
      despachoVTX: [],
      anulationCollenctionAccount: false,
      listSaleEntityCDWithDirectSale: [],
      hierarchies: ['division','area','departmento','linea']
    },
    {
      code: 'HESA',
      name: 'PROMART ECUADOR',
      applyPromotionDiscount: true,
      printGuideToSendTrip: false,
      applyMeasurableProductSale: true,
      applySkuDuplicate: true,
      applySaleEntityCd: false,
      applySaleOfServices: true,
      default: false,
      despachoVTX: [],
      anulationCollenctionAccount: false,
      listSaleEntityCDWithDirectSale: [],
      hierarchies: ['division','area','departmento','linea'],
      showOcInputs: true
    }
  ]
};

export const REAL_PLAZA_CODE = 'RP';
export const SUPERMERCADOS_CODE = 'SPSA'
export const OECHSLE_CODE = 'OE'
export const PROMART_CODE = 'PRO'
export const PROMART_ECUADOR_CODE = 'HESA'
export const AGORA_CODE = 'AGO'
export const STORE_TYPE_JOKR = 'TIENDA JOKR'
